import type { IconProps } from '../types/IconProps.ts';
export const SearchMinus: IconProps = {
    name: 'SearchMinus',
    children: [
        `<path d="M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16M16.95 17.05 21 21M8 11h6" />`,
    ]
};